@use 'styles/mixins/fonts' as *;

.mediumText {
    @include mediumFont;
}
